import { countryStores, type SupportedCountryCode } from "../constants/countries";

export const storeSelector = (item: string) => {
  window.open(countryStores[item as SupportedCountryCode]);
};
